import { Observable } from '@microsoft/fast-element';
import { DI } from '@microsoft/fast-foundation';
import { ICriteriaObject } from '../routes/market-depth/market-depth';

export interface IMarketDepthService {
  criteriaList: ICriteriaObject[];
  selectedVppaId: string;
}

class MarketDepthServiceImpl implements IMarketDepthService {
  constructor() {}
  private _criteriaList: ICriteriaObject[] = [];
  selectedVppaId: string = '';

  get criteriaList() {
    Observable.track(this, 'criteriaList');
    if (sessionStorage.getItem('criteria')) {
        return JSON.parse(sessionStorage.getItem('criteria'));
    } else {
        return this._criteriaList;
    }
  }

  set criteriaList(criteria: ICriteriaObject[]) {
    sessionStorage.setItem('criteria', JSON.stringify(criteria))
    this._criteriaList = criteria;
    Observable.notify(this, 'criteriaList');
  }

}

export const IMarketDepthService = DI.createInterface<IMarketDepthService>((x) =>
  x.singleton(MarketDepthServiceImpl)
);
